module.exports = __webpack_public_path__ + "static/media/israel.5aaaa756.png";